var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout"},[(_vm.$auth.$state.loggedIn)?_c('Navigation'):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('UpgradeCheckout'),_vm._v(" "),_c('PortalTarget',{attrs:{"name":"modals","multiple":""}}),_vm._v(" "),_c('BeforeUnloadModal')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }